import { render, staticRenderFns } from "./SectionClassification.vue?vue&type=template&id=6b69e1a5&scoped=true&"
import script from "./SectionClassification.vue?vue&type=script&lang=ts&"
export * from "./SectionClassification.vue?vue&type=script&lang=ts&"
import style0 from "./SectionClassification.vue?vue&type=style&index=0&id=6b69e1a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69e1a5",
  null
  
)

export default component.exports